import axios from 'axios';
import Qs from 'qs';
import router from '../router'
import {
	config
} from "../../WebConfig";
console.log('networdk', config)
import {
	Dialog,
	Toast
} from 'vant';
var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
let IsWX = false
if (ua.match(/MicroMessenger/i) == "micromessenger") {
	IsWX = true
}
let loadingOb = {
	message: '请稍后...',
	loadingType: 'spinner',
	forbidClick: true,
	duration: 0, //展示时长(ms)，值为 0 时，toast 不会消失
	className: 'leoloading'
}
export function post(url, data, success, fail, complete) {
	data.token = getCookie('token');
	Toast.loading(loadingOb);
	return new Promise((resolve, reject) => {
		axios.post(config.ROOT + url, Qs.stringify(data), {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
			.then(function(res) {
				resolve(res.data);
				Toast.clear()
				if (res.data.code == 0) {
					Dialog.alert({
						title: '温馨提示',
						message: res.data.msg
					}).then(() => {
						if (data.goBack) {
							router.go(-1)
						} else {
							fail && fail(res.data);
						}
					});
					// Dialog.alert({
					// 	title: '温馨提示',
					// 	message: res.data.msg
					// }).then(() => {fail && fail(res.data);});
				} else {
					success && success(res.data);
				}
				complete && complete();
			})
			.catch(function(err) {
				reject(err);
				Toast.clear()
				if (err.response) {
					if (err.response.data.code == 401) {
						//未登录
						if (IsWX)
							window.location.href = config.PROXYROOT +
							'/addons/litestore/api.uservue/connect?platform=wechat&url=' + window.location.href;
						else
							window.location.href = config.ROOT + '/index/user/login';
					}
					console.log(err.response)
				}
				fail && fail(err);
				complete && complete();
			})
	})
}


export function get(url, data, success, fail, complete) {
	data.token = getCookie('token');
	Toast.loading(loadingOb);
	var req = axios.get(config.ROOT + url, {
			params: data
		})
		.then(function(res) {
			Toast.clear()
			if (res.data.code == 0) {
				Dialog.alert({
					title: '温馨提示',
					message: res.data.msg
				}).then(() => {
					if (data.goBack) {
						router.go(-1)
					} else {
						fail && fail(res.data);
					}
				});
			} else {
				success && success(res.data);
			}
			complete && complete();
		})
		.catch(function(err) {
			Toast.clear()
			if (err.response) {
				if (err.response.data.code == 401) {
					//未登录
					if (IsWX)
						window.location.href = config.PROXYROOT +
						'/addons/litestore/api.uservue/connect?platform=wechat&url=' + window.location.href;
					else
						window.location.href = config.ROOT + '/index/user/login';
				}
				console.log(err.response)
			}
			fail && fail(err);
			complete && complete();
		})
}
/*export function isToken(s) {
	let tt = getCookie('token');
	alert('token:'+tt.length)
	if (tt.length > 0) {
		if (s == "" || s == null) {
			console.log('否店主', s)
			router.push('/my');
		}
	} else {
		console.log('未登录', tt)
		//未登录
		if (IsWX)
			window.location.href = config.PROXYROOT +
			'/addons/litestore/api.uservue/connect?platform=wechat&url=' + window.location.href;
		else
			window.location.href = config.ROOT + '/index/user/login';
	}
}*/

/**
 * 页面跳转
 */
export function redirect(path, debug = false) {

	if (path.indexOf('https://') > 0 || path.indexOf('http://') > 0) {
		window.location.href = path;
		return;
	}

	var protocol = location.protocol; //协议
	var hostname = location.hostname; //域名
	var port = location.port; //端口
	var url = protocol + '//' + hostname
	if (port) {
		url += ':' + port;
	}
	url += config.BASEPATH + path; //待跳转的链接

	if (process.env.NODE_ENV === 'development') {
		console.log('npm run serve', url)
	} else {
		console.log('npm run build', url)
	}

	if (debug) {
		console.log('跳转url', url);

	} else {
		window.location.href = url;
	}
}

function getCookie(c_name) {
	//判断document.cookie对象里面是否存有cookie
	if (document.cookie.length > 0) {
		var c_start = document.cookie.indexOf(c_name + "=")
		//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
		if (c_start != -1) {
			c_start = c_start + c_name.length + 1
			var c_end = document.cookie.indexOf(";", c_start)
			if (c_end == -1) c_end = document.cookie.length
			return unescape(document.cookie.substring(c_start, c_end))
		}
	}
	return ""
}

//设置cookie   name为cookie的名字，value是值，expiredays为过期时间（天数）

export function setCookie(name, value, expiredays) {

	var exdate = new Date();

	exdate.setDate(exdate.getDate() + expiredays);

	document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());

}

//删除cookie
function delCookie(name) {

	var exp = new Date();

	exp.setTime(exp.getTime() - 1);
	var cval = getCookie(name);

	if (cval != null)

		var expires = "expires=" + exp.toGMTString() + ";path=/"; //# 单斜杠 ‘/’表示项目当前根路径
	document.cookie = name + "=" + cval + ";expires=" + expires;

}


router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
		//console.log(to.name + '页面需要登录');

		if (getCookie('flag') || getCookie('uid') || getCookie('token')) { // 判断是否登录
			//console.log(getCookie('flag') , getCookie('uid') , getCookie('token')); return false
			next();
		} else {

			//console.log(111,getCookie('flag'));
			//return false;
			delCookie('token')
			delCookie('uid')
			delCookie('flag')
			/*window.location.href = config.PROXYROOT + '/addons/litestore/api.uservue/connect?platform=wechat&url=' + encodeURIComponent(window.location.href);
			return false;*/
			//alert(config.PROXYROOT);
			var callback_url = window.location.href;

			if (IsWX) {
				Dialog.confirm({
						title: '智慧旅业  申请',
						message: '获取您的昵称、头像',
						confirmButtonText: '立即授权',
						cancelButtonText: '我再想想',
					}).then(() => {
						// on confirm
						if (to.name == 'Goods') {
							callback_url = getCookie('CALLBACK_URL');
							delCookie('CALLBACK_URL');
						}

						window.location.href = config.PROXYROOT +
							'/addons/litestore/api.uservue/connect?platform=wechat&url=' +
							encodeURIComponent(callback_url);
					})
					.catch(() => {
						// on cancel
						//router.go(-1)

						window.location.href = config.ROOT + '/index/user/login?url=' + encodeURIComponent(
							callback_url);
					});

			} else {

				window.location.href = config.ROOT + '/index/user/login';
			}
		}
	} else {
		next();
	}
});

/*router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否需要登录权限
		console.log('需要登录',getCookie('token'));
		if (getCookie('token')) { // 判断当前的token是否存在 ； 登录存入的token
			next();
		}
		else {

			var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
			let IsWX = false
			if (ua.match(/MicroMessenger/i) == "micromessenger") {
				IsWX = true
			}
			//未登录 process.env.NODE_ENV === 'development' ? 'assets/addons/litestore/vue-mobile/' :
			var url = config.ROOT + '/index/user/login';
			//alert(url)
			if (IsWX) {
				url = 'https://www.jonlv.com/addons/litestore/api.uservue/connect?platform=wechat&url=' + window.location.href;
			}
			//alert(url);
			window.location.href = url;
		}
	}
	else {
		next();
	}
})*/
